import React from "react";
import { Reveal } from "../Reveal";
import { useForm } from "../../context/FormContext";
import { IMAGES } from "../../config";

const SHOTS = [
  { src: IMAGES.classroom, alt: "Classroom seating arrangement at DMediaClub", label: "Classroom setup", concept: false, span: "sm:col-span-2" },
  { src: IMAGES.openfloor, alt: "Open floor with mirrored wall", label: "Open floor", concept: false, span: "" },
  { src: IMAGES.empty, alt: "Bright empty studio ready for your idea", label: "Blank canvas", concept: false, span: "" },
  { src: IMAGES.movement, alt: "Movement and wellness configuration", label: "Movement", concept: true, span: "sm:col-span-2" },
];

export function Gallery() {
  const { scrollToId } = useForm();
  return (
    <section id="gallery" className="bg-berry py-20 md:py-28 text-cream">
      <div className="max-w-[1320px] mx-auto px-5 md:px-8">
        <Reveal><span className="sticker" style={{ background: "#FBE08A" }}>The space</span></Reveal>
        <div className="mt-6 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <Reveal delay={0.05}>
            <h2 className="display text-4xl sm:text-5xl md:text-6xl max-w-2xl">One room, many setups.</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-cream/80 max-w-md">A flexible creative studio in Orlando that adapts to your booking — from chairs-only classrooms to an open, mirrored movement floor.</p>
          </Reveal>
        </div>
        <div className="mt-12 grid sm:grid-cols-3 gap-5">
          {SHOTS.map((s, i) => (
            <Reveal key={i} delay={i * 0.06} y={24} className={s.span}>
              <div className="card-soft relative overflow-hidden bg-cream h-[240px] md:h-[300px]">
                <img src={s.src} alt={s.alt} loading="lazy" className="w-full h-full object-cover" />
                {s.concept && <span className="visual-concept">Visual Concept</span>}
                <span className="absolute top-3 left-3 sticker bg-butter text-charcoal text-xs" style={{ boxShadow: "2px 2px 0 #2A1020" }}>{s.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <button onClick={() => scrollToId("pricing")} className="btn mt-10 bg-butter text-charcoal border-2 border-charcoal px-7 py-4 shadow-[4px_4px_0_#2A1020]">
            See pricing & amenities
          </button>
        </Reveal>
      </div>
    </section>
  );
}
